export const CODE_SNIPPET_CONSTANTS = [
  { tabId: "1", label: "PHP", language: "php" },
  { tabId: "2", label: "Java", language: "java" },
  { tabId: "3", label: "CSharp", language: "csharp" },
  { tabId: "4", label: "NodeJS", language: "js" },
  { tabId: "5", label: "Other", language: "text" },
];

export function createCheckoutSessionCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    $payload = '${JSON.stringify(data.requestParamaters)}';
    $headers = array('x-amz-pay-Idempotency-Key' => uniqid());
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->createCheckoutSession(json_decode($payload, true), $headers);
        if ($result['status'] === 201) {
            
            $response = json_decode($result['response'], true);
            $checkoutSessionId = $response['checkoutSessionId'];

        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        String checkoutSessionId = null;
        JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}";  

        Map<String,String> header = new HashMap<String,String>();
        header.put("x-amz-pay-idempotency-key", UUID.randomUUID().toString().replace("-", ""));
                
        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.createCheckoutSession(payload, header);
        checkoutSessionId = response.getResponse().getString("checkoutSessionId");
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // prepare the request
        var request = new CreateCheckoutSessionRequest
        (
            checkoutReviewReturnUrl: "${data.requestParamaters.webCheckoutDetails.checkoutReviewReturnUrl}",
            storeId: "${data.requestParamaters.storeId}"
        )
        {
            ${(typeof data.requestParamaters.chargePermissionType === 'string') 
                ? `\tChargePermissionType = ChargePermissionType.${data.requestParamaters.chargePermissionType},` : ``}
            ${(typeof data.requestParamaters.paymentMethodOnFileMetadata.setupOnly == 'boolean') 
                ? `\tPaymentMethodOnFileMetadata = new PaymentMethodOnFileMetadata()\n\t\t{\n\t\t\tSetupOnly = ${data.requestParamaters.paymentMethodOnFileMetadata.setupOnly}\n\t\t},` : ``}
            ${(typeof data.requestParamaters.paymentDetails.paymentIntent === 'string') 
                ? `\tPaymentDetails = new PaymentDetails()\n\t\t{\n\t\t\tPaymentIntent = PaymentIntent.${data.requestParamaters.paymentDetails.paymentIntent}\n\t\t}` : ``}
        };
        ${(typeof data.requestParamaters.webCheckoutDetails.checkoutResultReturnUrl === 'string') ? 
            `request.WebCheckoutDetails.CheckoutResultReturnUrl = "${data.requestParamaters.webCheckoutDetails.checkoutResultReturnUrl}";` : ``}

        // Optional: add address restriction to limit which shipping addresses can be selected (here US addresses will be allowed only)

        // send the request
        CheckoutSessionResponse result = client.CreateCheckoutSession(request);

        // check if API call was successful
        if (!result.Success)
        {
            // do something, e.g. throw an error
        }
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
const uuidv4 = require('uuid/v4');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region:  '${data.region}',
    sandbox: true
};
                
const payload = '${JSON.stringify(data.requestParamaters)}';
                        
const headers = {
    'x-amz-pay-idempotency-key': uuidv4().toString().replace(/-/g, '')
};
                
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.createCheckoutSession(payload, headers);`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}
    
${JSON.stringify(data.requestParamaters, null, 2)}`,
  };
}

export function getCheckoutSessionCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->getCheckoutSession('${data.pathParam}');
        if ($result['status'] === 200) {
            $response = json_decode($result['response'], true);
            $checkoutSessionState = $response['statusDetails']['state'];
            $chargeId = $response['chargeId'];
            $chargePermissionId = $response['chargePermissionId'];

            // NOTE: Once Checkout Session moves to a "Completed" state, buyer and shipping
            // details must be obtained from the getChargePermission() function call instead
            $buyerName = $response['buyer']['name'];
            $buyerEmail = $response['buyer']['email'];
            $paymentDescriptor = $response['paymentPreferences'][0]['paymentDescriptor'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
        public void sample() { 
public void sample() {
        public void sample() { 
public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.getCheckoutSession('${data.pathParam}');
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // send the request
        CheckoutSessionResponse result = client.GetCheckoutSession("${data.pathParam}");

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }

        // do something with the result, for instance:
        var checkoutSessionState = result.StatusDetails.State;

        Buyer buyer = result.Buyer;
        Address shippingAddress = result.ShippingAddress;
        // ...
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region:  '${data.region}',
    sandbox: true
};
                
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.getCheckoutSession('${data.pathParam}');`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}`,
  };
}

export function updateCheckoutSessionCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    $payload = '${JSON.stringify(data.requestParamaters)}';
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->updateCheckoutSession('${data.pathParam}', json_decode($payload, true));

        if ($result['status'] === 201) {
            
            $response = json_decode($result['response'], true);
            $checkoutSessionId = $response['checkoutSessionId'];

        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}");  

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.updateCheckoutSession("${data.pathParam}",payload);
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);
        
        // prepare the request
        var request = new UpdateCheckoutSessionRequest()
        {   
            WebCheckoutDetails = { 
                CheckoutResultReturnUrl =  "https://localhost/store/checkout_return" 
            },
            PaymentDetails = {
                PaymentIntent = "${data.requestParamaters.paymentDetails.paymentIntent ? data.requestParamaters.paymentDetails.paymentIntent : ''}",
                CanHandlePendingAuthorization = ${data.requestParamaters.paymentDetails.canHandlePendingAuthorization ? data.requestParamaters.paymentDetails.canHandlePendingAuthorization: false},
                ChargeAmount = {Amount = ${data.requestParamaters.paymentDetails.chargeAmount.amount ? data.requestParamaters.paymentDetails.chargeAmount.amount : ''}, CurrencyCode = Currency.${data.requestParamaters.paymentDetails.chargeAmount.currencyCode ? data.requestParamaters.paymentDetails.chargeAmount.currencyCode : ''}}
            },
            MerchantMetadata = { 
                MerchantReferenceId = "${data.requestParamaters.merchantMetadata.merchantReferenceId ? data.requestParamaters.merchantMetadata.merchantReferenceId : ''}",
                MerchantStoreName = "${data.requestParamaters.merchantMetadata.merchantStoreName ? data.requestParamaters.merchantMetadata.merchantStoreName : ''}", 
                NoteToBuyer = "${data.requestParamaters.merchantMetadata.noteToBuyer ? data.requestParamaters.merchantMetadata.noteToBuyer : ''}",
                CustomInformation = "${data.requestParamaters.merchantMetadata.customInformation ? data.requestParamaters.merchantMetadata.customInformation : ''}",
            },
        };

        // send the request
        ChargePermissionResponse result = client.UpdateCheckoutSessionRequest("${data.pathParam}", request);

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }

        // do something with the result, for instance:
        string chargePermissionState = result.StatusDetails.State;
        DateTime chargePermissionExpiryDate = result.ExpirationTimestamp;
        Address buyerAddress = result.BillingAddress;
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
const uuidv4 = require('uuid/v4');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region:  '${data.region}',
    sandbox: true
};
                
const payload = '${JSON.stringify(data.requestParamaters)}';
                        
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.updateCheckoutSession('${data.pathParam}',payload);`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}
    
${JSON.stringify(data.requestParamaters, null, 2)}`,
  };
}

export function completeCheckoutSessionCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    $payload = '${JSON.stringify(data.requestParamaters)}';

    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->completeCheckoutSession('${data.pathParam}', json_decode($payload, true));
        
        if ($result['status'] === 201) {
            
            $response = json_decode($result['response'], true);
            $checkoutSessionId = $response['checkoutSessionId'];

        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}");  

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.completeCheckoutSession("${data.pathParam}",payload);
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // prepare the request
        var request = new CompleteCheckoutSessionRequest("${data.requestParamaters.chargeAmount.amount}", Currency.${data.requestParamaters.chargeAmount.currencyCode});

        // send the request
        var result = client.CompleteCheckoutSession("${data.pathParam}", request);

        // check if API call was successful
        if (!result.Success)
        {
            // do something, e.g. throw an error
        }
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
const uuidv4 = require('uuid/v4');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region: '${data.region}',
    sandbox: true
};
                
const payload = '${JSON.stringify(data.requestParamaters)}';
                        
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.completeCheckoutSession('${data.pathParam}',payload);`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}
    
${JSON.stringify(data.requestParamaters, null, 2)}`,
  };
}

export function getChargePermissionCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->getChargePermission('${data.pathParam}');
        
        if ($result['status'] === 200) {
            $response = json_decode($result['response'], true);
            $chargePermissionState = $response['statusDetails']['state'];

        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.getChargePermission('${data.pathParam}');
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // send the request
        ChargePermissionResponse result = client.GetChargePermission("${data.pathParam}");

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }

        // do something with the result, for instance:
        string chargePermissionState = result.StatusDetails.State;
        DateTime chargePermissionExpiryDate = result.ExpirationTimestamp;
        Address buyerAddress = result.BillingAddress;
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region: '${data.region}',
    sandbox: true
};
                
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.getChargePermission('${data.pathParam}');`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}`,
  };
}

export function updateChargePermissionCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    $payload = '${JSON.stringify(data.requestParamaters)}';
    $headers = array('x-amz-pay-Idempotency-Key' => uniqid());
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->updateChargePermission('${data.pathParam}', json_decode($payload, true));
        
        if ($result['status'] === 200) {
            $response = json_decode($result['response'], true);
            
        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}");  

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.updateChargePermission("${data.pathParam}",payload);
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // prepare the request
        var request = new UpdateChargePermissionRequest()
        {
            MerchantMetadata = { 
                MerchantReferenceId = "${data.requestParamaters.merchantMetadata.merchantReferenceId}",
                MerchantStoreName = "${data.requestParamaters.merchantMetadata.merchantStoreName}", 
                NoteToBuyer = "${data.requestParamaters.merchantMetadata.noteToBuyer}",
                CustomInformation = "${data.requestParamaters.merchantMetadata.customInformation}",
            },
            RecurringMetadata = {
                FrequencyUnit = "${data.requestParamaters.recurringMetadata.frequency.unit}",
                Value = "${data.requestParamaters.recurringMetadata.frequency.value}",
                Amount = "${data.requestParamaters.recurringMetadata.amount.amount}",
                CurrencyCode = "${data.requestParamaters.recurringMetadata.amount.currencyCode}"
            }
        };

        // send the request
        ChargePermissionResponse result = client.UpdateChargePermission("${data.pathParam}", request);

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }

        // do something with the result, for instance:
        string chargePermissionState = result.StatusDetails.State;
        DateTime chargePermissionExpiryDate = result.ExpirationTimestamp;
        Address buyerAddress = result.BillingAddress;
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
const uuidv4 = require('uuid/v4');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region: '${data.region}',
    sandbox: true
};
                
const payload = '${JSON.stringify(data.requestParamaters)}';
                        
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.updateChargePermission('${data.pathParam}',payload);`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}
    
${JSON.stringify(data.requestParamaters, null, 2)}`,
  };
}

export function closeChargePermissionCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    $payload = '${JSON.stringify(data.requestParamaters)}';

    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->closeChargePermission('${data.pathParam}', json_decode($payload, true));
        
        if ($result['status'] === 200) {
            $response = json_decode($result['response'], true);
            $chargePermissionState = $response['statusDetails']['state'];
            
        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}");  

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.closeChargePermission("${data.pathParam}",payload);
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // prepare the request
        var request = new CloseChargePermissionRequest("${data.requestParamaters.closureReason}");
        ${(typeof data.requestParamaters.cancelPendingCharges === 'boolean') ? `request.CancelPendingCharges = ${data.requestParamaters.cancelPendingCharges};` : ``}
        
        // send the request
        ChargePermissionResponse result = client.CloseChargePermission("${data.pathParam}", request);

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }

        // do something with the result, for instance:
        string chargePermissionState = result.StatusDetails.State;
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
const uuidv4 = require('uuid/v4');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region: '${data.region}',
    sandbox: true
};
                
const payload = '${JSON.stringify(data.requestParamaters)}';
                        
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.closeChargePermission('${data.pathParam}',payload);`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}
    
${JSON.stringify(data.requestParamaters, null, 2)}`,
  };
}

export function getChargeCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => ${data.region},
        'sandbox'       => true
    );
        
    try {
        $client = new Amazon\Pay\API\Client($amazonpay_config);
        $result = $client->getCharge('${data.pathParam}');
        
        if ($result['status'] === 200) {
            $response = json_decode($result['response'], true);
            $chargeState = $response['statusDetails']['state'];

        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.getCharge('${data.pathParam}');
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // send the request
        ChargeResponse result = client.GetCharge("${data.pathParam}");

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }

        // do something with the result, for instance:
        string chargeState = result.StatusDetails.State;
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region: '${data.region}',
    sandbox: true
};
                
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.getCharge('${data.pathParam}');`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}`,
  };
}

export function createChargeCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    $payload = '${JSON.stringify(data.requestParamaters)}';
    $headers = array('x-amz-pay-Idempotency-Key' => uniqid());
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->createCharge(json_decode($payload, true), $headers);
        
        if ($result['status'] === 201) {
            $response = json_decode($result['response'], true);
            $chargeState = $response['statusDetails']['state'];
            $chargeId = $response['chargeId'];

        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
        public void sample() {    
public void sample() {
        public void sample() {    
public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}";  

        Map<String,String> header = new HashMap<String,String>();
        header.put("x-amz-pay-idempotency-key", UUID.randomUUID().toString().replace("-", ""));
                
        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.createCharge(payload, header);
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);
        
        // prepare the request
        var request = new CreateChargeRequest("${data.requestParamaters.chargePermissionId}", ${data.requestParamaters.chargeAmount.amount}, Currency.${data.requestParamaters.chargeAmount.currencyCode})
        {
            CaptureNow = ${data.requestParamaters.captureNow ? data.requestParamaters.captureNow : false},
            SoftDescriptor = "${data.requestParamaters.softDescriptor ? data.requestParamaters.softDescriptor : ''}",
            CanHandlePendingAuthorization = ${data.requestParamaters.canHandlePendingAuthorization ? data.requestParamaters.canHandlePendingAuthorization : false},
            MerchantMetadata = { 
                MerchantReferenceId = "${data.requestParamaters.merchantMetadata.merchantReferenceId ? data.requestParamaters.merchantMetadata.merchantReferenceId : ''}",
                MerchantStoreName = "${data.requestParamaters.merchantMetadata.merchantStoreName ? data.requestParamaters.merchantMetadata.merchantStoreName : ''}", 
                NoteToBuyer = "${data.requestParamaters.merchantMetadata.noteToBuyer ? data.requestParamaters.merchantMetadata.noteToBuyer : ''}",
                CustomInformation = "${data.requestParamaters.merchantMetadata.customInformation ? data.requestParamaters.merchantMetadata.customInformation : ''}",
            },
            ${(typeof data.requestParamaters.channel === 'string') ? `Channel = "${data.requestParamaters.channel}",` : ``}
            ${(typeof data.requestParamaters.chargeInitiator === 'string') ? `ChargeInitiator = "${data.requestParamaters.chargeInitiator}"` : ``} 
        };

        // send the request
        ChargeResponse result = client.CreateCharge(request);

        // check if API call was successful
        if (!result.Success)
        {
            // do something, e.g. throw an error
        }
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
const uuidv4 = require('uuid/v4');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region:  '${data.region}',
    sandbox: true
};
                
const payload = '${JSON.stringify(data.requestParamaters)}';
                        
const headers = {
    'x-amz-pay-idempotency-key': uuidv4().toString().replace(/-/g, '')
};
                
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.createCharge(payload, headers);`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}
    
${JSON.stringify(data.requestParamaters, null, 2)}`,
  };
}

export function captureChargeCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    $payload = '${JSON.stringify(data.requestParamaters)}';
    $headers = array('x-amz-pay-Idempotency-Key' => uniqid());
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->captureCharge('${
          data.pathParam
        }', json_decode($payload, true), $headers);
        
        if ($result['status'] === 200) {
            $response = json_decode($result['response'], true);
            $state = $response['statusDetails']['state'];
            $reasonCode = $response['statusDetails']['reasonCode'];
            $reasonDescription = $response['statusDetails']['reasonDescription'];
            
        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
        public void sample() {    
public void sample() {
        public void sample() {    
public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}";  

        Map<String,String> header = new HashMap<String,String>();
        header.put("x-amz-pay-idempotency-key", UUID.randomUUID().toString().replace("-", ""));
                
        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.captureCharge("${data.pathParam}", payload, header);
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // prepare the request        
        var request = new CaptureChargeRequest(${data.requestParamaters.captureAmount.amount}, Currency.${data.requestParamaters.captureAmount.currencyCode}) { SoftDescriptor = "${data.requestParamaters.softDescriptor ? data.requestParamaters.softDescriptor : ''}" };

        // send the request
        ChargeResponse result = client.CaptureCharge("${data.pathParam}", request);

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }

        // do something with the result, for instance:
        string chargeState = result.StatusDetails.State;
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
const uuidv4 = require('uuid/v4');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region:  '${data.region}',
    sandbox: true
};
                
const payload = '${JSON.stringify(data.requestParamaters)}';
                        
const headers = {
    'x-amz-pay-idempotency-key': uuidv4().toString().replace(/-/g, '')
};
                
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.captureCharge(${data.pathParam}, payload, headers);`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}
    
${JSON.stringify(data.requestParamaters, null, 2)}`,
  };
}

export function cancelChargeCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    $payload = '${JSON.stringify(data.requestParamaters)}';
    $headers = array('x-amz-pay-Idempotency-Key' => uniqid());
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->cancelCharge('${data.pathParam}', json_decode($payload, true));
        
        if ($result['status'] === 200) {
            $response = json_decode($result['response'], true);
            $chargeState = $response['statusDetails']['state'];
            
        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}");  

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.cancelCharge("${data.pathParam}",payload);
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // prepare the request
        var request = new CancelChargeRequest("${data.requestParamaters.cancellationReason}");

        // send the request
        ChargeResponse result = client.CancelCharge("${data.pathParam}", request);

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }

        // do something with the result, for instance:
        string chargeState = result.StatusDetails.State;
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
const uuidv4 = require('uuid/v4');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region:  '${data.region}',
    sandbox: true
};
                
const payload = '${JSON.stringify(data.requestParamaters)}';
                        
const headers = {
    'x-amz-pay-idempotency-key': uuidv4().toString().replace(/-/g, '')
};
                
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.cancelCharge('${data.pathParam}',payload);`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}
    
${JSON.stringify(data.requestParamaters, null, 2)}`,
  };
}

export function createRefundCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    $payload = '${JSON.stringify(data.requestParamaters)}';
    $headers = array('x-amz-pay-Idempotency-Key' => uniqid());
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->createRefund(json_decode($payload, true), $headers);
        
        if ($result['status'] === 201) {
            $response = json_decode($result['response'], true);
            $refundState = $response['statusDetails']['state'];
            $refundId = $response['refundId'];

        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}";  

        Map<String,String> header = new HashMap<String,String>();
        header.put("x-amz-pay-idempotency-key", UUID.randomUUID().toString().replace("-", ""));
                
        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.createRefund(payload, header);
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);
        
        // prepare the request
        var request = new CreateRefundRequest("${data.requestParamaters.chargeId}", ${data.requestParamaters.refundAmount.amount}, Currency.${data.requestParamaters.refundAmount.currencyCode});
        // send the request
        RefundResponse result = client.CreateRefund(request);

        // check if API call was successful
        if (!result.Success)
        {
            // do something, e.g. throw an error
        }
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
const uuidv4 = require('uuid/v4');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region:  '${data.region}',
    sandbox: true
};
                
const payload = '${JSON.stringify(data.requestParamaters)}';
                        
const headers = {
    'x-amz-pay-idempotency-key': uuidv4().toString().replace(/-/g, '')
};
                
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.createRefund(payload, headers);`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}
    
${JSON.stringify(data.requestParamaters, null, 2)}`,
  };
}

export function getRefundCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->getRefund('${data.pathParam}');
        
        if ($result['status'] === 200) {
            $response = json_decode($result['response'], true);
            $chargeState = $response['statusDetails']['state'];

        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.getRefund('${data.pathParam}');
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // send the request
        RefundResponse result = client.GetRefund("${data.pathParam}");

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }

        // do something with the result, for instance:
        string refundState = result.StatusDetails.State;
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region:  '${data.region}',
    sandbox: true
};
                
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.getRefund('${data.pathParam}');`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}`,
  };
}

export function getBuyerCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->getBuyer('${data.pathParam}');
        
        if ($result['status'] === 200) {
            $response = json_decode($result['response'], true);

        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.getBuyer('${data.pathParam}');
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        BuyerResponse result = client.GetBuyer("${data.pathParam}");

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }

        // do something with the result, for instance:
        string buyerId = result.BuyerId;
        Address buyerAddress = result.ShippingAddress;
        string buyerEmail = result.Email;
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region:  '${data.region}',
    sandbox: true
};
                
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.getBuyer('${data.pathParam}');`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}`,
  };
}

export function deliveryTrackerCodeSnippet(data) {
  if (Object.keys(data).length === 0) {
    return "";
  }
  return {
    php: `
<?php

    include 'vendor/autoload.php';

    $amazonpay_config = array(
        'public_key_id' => '${data.publicKeyId}',
        'private_key'   => 'YOUR_PRIVATE_KEY',
        'region'        => '${data.region}',
        'sandbox'       => true
    );
        
    $payload = '${JSON.stringify(data.requestParamaters)}';
    try {
        $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
        $result = $client->deliveryTrackers(json_decode($payload, true));
        
        if ($result['status'] === 200) {
            // success
            echo $result['response'];
        } else {
            // check the error
            echo 'status=' . $result['status'] . '; response=' . $result['response'];
        }
    } catch (\Exception $e) {
        // handle the exception
        echo $e;
    }
?>`,
    java: `
import com.amazon.pay.api.AmazonPayResponse;
import com.amazon.pay.api.PayConfiguration;
import com.amazon.pay.api.WebstoreClient;
import com.amazon.pay.api.exceptions.AmazonPayClientException;

public void sample() {
    PayConfiguration payConfiguration = null;
    try {
        payConfiguration = new PayConfiguration()
            .setPublicKeyId("${data.publicKeyId}")
            .setRegion(Region.${data.region.toUpperCase()})
            .setPrivateKey("YOUR_PRIVATE_KEY")
            .setEnvironment(Environment.SANDBOX);

        JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}";  

        WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
        AmazonPayResponse response = webstoreClient.deliveryTracker(payload);
    } catch (AmazonPayClientException e) {
        e.printStackTrace();
    }
}`,
    csharp: `
using Amazon.Pay.API.Types;
using Amazon.Pay.API.WebStore;

public class Sample
{
    public WebStoreClient InitiateClient()
    {
        // set up config
        var payConfiguration = new ApiConfiguration
        (
            region: Region.${data.region.toUpperCase()},
            environment: Environment.Sandbox,
            publicKeyId: "${data.publicKeyId}",
            privateKey: "YOUR_PRIVATE_KEY"
        );

        // init API client
        var client = new WebStoreClient(payConfiguration);

        // prepare the request
        var request = new Amazon.Pay.API.DeliveryTracker.DeliveryTrackerRequest("${data.requestParamaters.chargePermissionId}", true, "${data.requestParamaters.deliveryDetails.trackingNumber}", "${data.requestParamaters.deliveryDetails.carrierCode}");

        // send the request
        var result = client.SendDeliveryTrackingInformation(request);

        // check if API call was successful
        if (!result.Success)
        {
            // handle the API error (use Status field to get the numeric error code)
        }
    }
}`,
    nodejs: `
const fs = require('fs');
const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
const uuidv4 = require('uuid/v4');

const config = {
    publicKeyId: '${data.publicKeyId}',
    privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
    region:  '${data.region}',
    sandbox: true
};
                
const payload = '${JSON.stringify(data.requestParamaters)}';
                        
const testPayClient = new Client.WebStoreClient(config);
const response = testPayClient.deliveryTrackers(payload);`,
    other: `
${data.method} ${data.urlFragment} HTTP/1.1
Accept: application/json
Authorization: ${data.authorization}       
X-Amz-Pay-Date: ${data.date}
X-Amz-Pay-Host: ${data.host}
X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
X-Amz-Pay-Region: ${data.region}
Content-type: application/json
Host : ${data.host}
    
${JSON.stringify(data.requestParamaters, null, 2)}`,
  };
}
export function getReportsCodeSnippet(data) {
    if (Object.keys(data).length === 0) {
      return "";
    }
    return {
      php: `
  <?php
  
      include 'vendor/autoload.php';
  
      $amazonpay_config = array(
          'public_key_id' => '${data.publicKeyId}',
          'private_key'   => 'YOUR_PRIVATE_KEY',
          'region'        => '${data.region}',
          'sandbox'       => true
      );
          
      $payload = '${JSON.stringify(data.requestParamaters)}';
  
      try {
          $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
          $result = $client->getReports(json_decode($payload, true));
          
          if ($result['status'] === 200) {
              $response = json_decode($result['response'], true);
              print_r($response);
              
          } else {
              // check the error
              echo 'status=' . $result['status'] . '; response=' . $result['response'];
          }
      } catch (\Exception $e) {
          // handle the exception
          echo $e;
      }
  ?>`,
      java: `
  import com.amazon.pay.api.AmazonPayResponse;
  import com.amazon.pay.api.PayConfiguration;
  import com.amazon.pay.api.WebstoreClient;
  import com.amazon.pay.api.exceptions.AmazonPayClientException;
  
  public void sample() {
      PayConfiguration payConfiguration = null;
      try {
          payConfiguration = new PayConfiguration()
              .setPublicKeyId("${data.publicKeyId}")
              .setRegion(Region.${data.region.toUpperCase()})
              .setPrivateKey("YOUR_PRIVATE_KEY")
              .setEnvironment(Environment.SANDBOX);
  
          JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}");  
  
          WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
          AmazonPayResponse response = webstoreClient.getReports(payload);
      } catch (AmazonPayClientException e) {
          e.printStackTrace();
      }
  }`,
  csharp: `
  using Amazon.Pay.API.Types;
  using Amazon.Pay.API.WebStore;
  using Amazon.Pay.API.WebStore.Reports;
  using System;
  using System.Collections.Generic;
  
  public class Sample
  {
      public WebStoreClient InitiateClient()
      {
          // set up config
          var payConfiguration = new ApiConfiguration
          (
              region: Region.${data.region.toUpperCase()},
              environment: Environment.Sandbox,
              publicKeyId: "${data.publicKeyId}",
              privateKey: "YOUR_PRIVATE_KEY"
          );
  
          // init API client
          var client = new WebStoreClient(payConfiguration);
  
          // prepare the request
          var request = new GetReportsRequest();
          ${(typeof data.requestParamaters.reportTypes === 'string') ? `request.ReportTypes = new List<ReportTypes> {ReportTypes.${data.requestParamaters.reportTypes}};` : ``}
          ${(typeof data.requestParamaters.processingStatuses === 'string') ? `request.ProcessingStatuses = new List<ProcessingStatus> {ProcessingStatus.${data.requestParamaters.processingStatuses}};` : ``}
          ${(typeof data.requestParamaters.createdSince === 'string') ? `request.CreatedSince = ${data.requestParamaters.createdSince};` : ``}
          ${(typeof data.requestParamaters.createdUntil === 'string') ? `request.CreatedUntil = ${data.requestParamaters.createdUntil};` : ``}
          ${(typeof data.requestParamaters.pageSize === 'string') ? `request.PageSize = ${data.requestParamaters.pageSize};` : ``}
          ${(typeof data.requestParamaters.nextToken === 'string') ? `request.NextToken = ${data.requestParamaters.nextToken};` : ``}
          
          var myHeaderKey = "x-amz-pay-idempotency-key";
          var myHeaderValue = Guid.NewGuid().ToString();
          var headers = new Dictionary<string, string> { { myHeaderKey, myHeaderValue } };
 
          // send the request
          GetReportsResponse result = client.GetReports(request, headers);
  
          // check if API call was successful
          if (!result.Success)
          {
              // handle the API error (use Status field to get the numeric error code)
          }
  
          // do something with the result, for instance:
          Console.WriteLine(report.RawResponse);
      }
  }`,
      nodejs: `
  const fs = require('fs');
  const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
  const uuidv4 = require('uuid/v4');
  
  const config = {
      publicKeyId: '${data.publicKeyId}',
      privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
      region: '${data.region}',
      sandbox: true
  };
                  
  const payload = '${JSON.stringify(data.requestParamaters)}';
                          
  const testPayClient = new Client.WebStoreClient(config);
  const response = testPayClient.getReports(payload);`,
      other: `
  ${data.method} ${data.urlFragment} HTTP/1.1
  Accept: application/json
  Authorization: ${data.authorization}       
  X-Amz-Pay-Date: ${data.date}
  X-Amz-Pay-Host: ${data.host}
  X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
  X-Amz-Pay-Region: ${data.region}
  Content-type: application/json
  Host : ${data.host}
      
  ${JSON.stringify(data.requestParamaters, null, 2)}`,
    };
  }
 
  export function getReportByIdCodeSnippet(data) {
    if (Object.keys(data).length === 0) {
      return "";
    }
    return {
      php: `
  <?php
  
      include 'vendor/autoload.php';
  
      $amazonpay_config = array(
          'public_key_id' => '${data.publicKeyId}',
          'private_key'   => 'YOUR_PRIVATE_KEY',
          'region'        => '${data.region}',
          'sandbox'       => true
      );
          
      try {
          $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
          $result = $client->getReportById('${data.pathParam}');
          if ($result['status'] === 200) {
              $response = json_decode($result['response'], true);
              print_r($response);
          }
      } catch (\Exception $e) {
          // handle the exception
          echo $e;
      }
  ?>`,
      java: `
  import com.amazon.pay.api.AmazonPayResponse;
  import com.amazon.pay.api.PayConfiguration;
  import com.amazon.pay.api.WebstoreClient;
  import com.amazon.pay.api.exceptions.AmazonPayClientException;
  
  public void sample() {
          public void sample() { 
  public void sample() {
          public void sample() { 
  public void sample() {
      PayConfiguration payConfiguration = null;
      try {
          payConfiguration = new PayConfiguration()
              .setPublicKeyId("${data.publicKeyId}")
              .setRegion(Region.${data.region.toUpperCase()})
              .setPrivateKey("YOUR_PRIVATE_KEY")
              .setEnvironment(Environment.SANDBOX);
  
          WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
          AmazonPayResponse response = webstoreClient.getReportById('${data.pathParam}');
      } catch (AmazonPayClientException e) {
          e.printStackTrace();
      }
  }`,
      csharp: `
  using Amazon.Pay.API.Types;
  using Amazon.Pay.API.WebStore;
  using Amazon.Pay.API.WebStore.Reports;
  using System;
  using System.Collections.Generic;
  
  public class Sample
  {
      public WebStoreClient InitiateClient()
      {
          // set up config
          var payConfiguration = new ApiConfiguration
          (
              region: Region.${data.region.toUpperCase()},
              environment: Environment.Sandbox,
              publicKeyId: "${data.publicKeyId}",
              privateKey: "YOUR_PRIVATE_KEY"
          );
  
          // init API client
          var client = new WebStoreClient(payConfiguration);
 
          // init Headers
          var myHeaderKey = "x-amz-pay-idempotency-key";
          var myHeaderValue = Guid.NewGuid().ToString();
          var headers = new Dictionary<string, string> { { myHeaderKey, myHeaderValue } };
  
          // send the request
          Report result = client.GetReportById("${data.pathParam}", headers);
  
          // check if API call was successful
          if (!result.Success)
          {
              // handle the API error (use Status field to get the numeric error code)
          }
  
          // do something with the result, for instance:
          Console.WriteLine(report.RawResponse);
      }
  }`,
      nodejs: `
  const fs = require('fs');
  const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
  
  const config = {
      publicKeyId: '${data.publicKeyId}',
      privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
      region:  '${data.region}',
      sandbox: true
  };
                  
  const testPayClient = new Client.WebStoreClient(config);
  const response = testPayClient.getReportById('${data.pathParam}');`,
      other: `
  ${data.method} ${data.urlFragment} HTTP/1.1
  Accept: application/json
  Authorization: ${data.authorization}       
  X-Amz-Pay-Date: ${data.date}
  X-Amz-Pay-Host: ${data.host}
  X-Amz-Pay-Region: ${data.region}
  Content-type: application/json
  Host : ${data.host}`,
    };
  }
 
  export function createReportCodeSnippet(data) {
    if (Object.keys(data).length === 0) {
      return "";
    }
    return {
      php: `
  <?php
  
      include 'vendor/autoload.php';
  
      $amazonpay_config = array(
          'public_key_id' => '${data.publicKeyId}',
          'private_key'   => 'YOUR_PRIVATE_KEY',
          'region'        => '${data.region}',
          'sandbox'       => true
      );
          
      $payload = '${JSON.stringify(data.requestParamaters)}';
      $headers = array('x-amz-pay-Idempotency-Key' => uniqid());
      try {
          $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
          $result = $client->createReport(json_decode($payload, true), $headers);
          if ($result['status'] === 200) {
              
              $response = json_decode($result['response'], true);
              print_r($response);
  
          } else {
              // check the error
              echo 'status=' . $result['status'] . '; response=' . $result['response'];
          }
      } catch (\Exception $e) {
          // handle the exception
          echo $e;
      }
  ?>`,
      java: `
  import com.amazon.pay.api.AmazonPayResponse;
  import com.amazon.pay.api.PayConfiguration;
  import com.amazon.pay.api.WebstoreClient;
  import com.amazon.pay.api.exceptions.AmazonPayClientException;
  
  public void sample() {
      PayConfiguration payConfiguration = null;
      try {
          payConfiguration = new PayConfiguration()
              .setPublicKeyId("${data.publicKeyId}")
              .setRegion(Region.${data.region.toUpperCase()})
              .setPrivateKey("YOUR_PRIVATE_KEY")
              .setEnvironment(Environment.SANDBOX);
  
          String reportId = null;
          JSONObject payload = new JSONObject("${JSON.stringify(data.requestParamaters).replace(/"/g, '\\"')}";  
  
          Map<String,String> header = new HashMap<String,String>();
          header.put("x-amz-pay-idempotency-key", UUID.randomUUID().toString().replace("-", ""));
                  
          WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
          AmazonPayResponse response = webstoreClient.createReport(payload, header);
          reportId = response.getResponse().getString("reportId");
      } catch (AmazonPayClientException e) {
          e.printStackTrace();
      }
  }`,
      csharp: `
  using Amazon.Pay.API.Types;
  using Amazon.Pay.API.WebStore;
  using Amazon.Pay.API.WebStore.Reports;
  using System;
  using System.Collections.Generic;
  
  public class Sample
  {
      public WebStoreClient InitiateClient()
      {
          // set up config
          var payConfiguration = new ApiConfiguration
          (
              region: Region.${data.region.toUpperCase()},
              environment: Environment.Sandbox,
              publicKeyId: "${data.publicKeyId}",
              privateKey: "YOUR_PRIVATE_KEY"
          );
  
          // init API client
          var client = new WebStoreClient(payConfiguration);
  
          // prepare the request
          var request = new CreateReportRequest
          (
              reportType: ReportTypes.${data.requestParamaters.reportType},
              startTime: "${data.requestParamaters.startTime}",
              endTime: "${data.requestParamaters.endTime}"
          );
          
          // init Headers
          var myHeaderKey = "x-amz-pay-idempotency-key";
          var myHeaderValue = Guid.NewGuid().ToString();
          var headers = new Dictionary<string, string> { { myHeaderKey, myHeaderValue } };
 
          // send the request
          CreateReportResponse result = client.CreateReport(request, headers);
  
          // check if API call was successful
          if (!result.Success)
          {
              // do something, e.g. throw an error
          }
 
          // do something with the result, for instance:
          Console.WriteLine(report.RawResponse);
      }
  }`,
      nodejs: `
  const fs = require('fs');
  const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
  const uuidv4 = require('uuid/v4');
  
  const config = {
      publicKeyId: '${data.publicKeyId}',
      privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
      region:  '${data.region}',
      sandbox: true
  };
                  
  const payload = '${JSON.stringify(data.requestParamaters)}';
                          
  const headers = {
      'x-amz-pay-idempotency-key': uuidv4().toString().replace(/-/g, '')
  };
                  
  const testPayClient = new Client.WebStoreClient(config);
  const response = testPayClient.createReport(payload, headers);`,
      other: `
  ${data.method} ${data.urlFragment} HTTP/1.1
  Accept: application/json
  Authorization: ${data.authorization}       
  X-Amz-Pay-Date: ${data.date}
  X-Amz-Pay-Host: ${data.host}
  X-Amz-Pay-Idempotency-Key: ${data.idempotencyKey}
  X-Amz-Pay-Region: ${data.region}
  Content-type: application/json
  Host : ${data.host}
      
  ${JSON.stringify(data.requestParamaters, null, 2)}`,
    };
  }
  
  export function getReportDocumentCodeSnippet(data) {
    if (Object.keys(data).length === 0) {
      return "";
    }
    return {
      php: `
  <?php
  
      include 'vendor/autoload.php';
  
      $amazonpay_config = array(
          'public_key_id' => '${data.publicKeyId}',
          'private_key'   => 'YOUR_PRIVATE_KEY',
          'region'        => '${data.region}',
          'sandbox'       => true
      );
          
      try {
          $client = new Amazon\\Pay\\API\\Client($amazonpay_config);
          $result = $client->getReportDocument('${data.pathParam}');
          if ($result['status'] === 200) {
              $response = json_decode($result['response'], true);
              print_r($response);
          }
      } catch (\Exception $e) {
          // handle the exception
          echo $e;
      }
  ?>`,
      java: `
  import com.amazon.pay.api.AmazonPayResponse;
  import com.amazon.pay.api.PayConfiguration;
  import com.amazon.pay.api.WebstoreClient;
  import com.amazon.pay.api.exceptions.AmazonPayClientException;
  
  public void sample() {
          public void sample() { 
  public void sample() {
          public void sample() { 
  public void sample() {
      PayConfiguration payConfiguration = null;
      try {
          payConfiguration = new PayConfiguration()
              .setPublicKeyId("${data.publicKeyId}")
              .setRegion(Region.${data.region.toUpperCase()})
              .setPrivateKey("YOUR_PRIVATE_KEY")
              .setEnvironment(Environment.SANDBOX);
  
          WebstoreClient webstoreClient = new WebstoreClient(payConfiguration);
          AmazonPayResponse response = webstoreClient.getReportDocument('${data.pathParam}');
      } catch (AmazonPayClientException e) {
          e.printStackTrace();
      }
  }`,
      csharp: `
  using Amazon.Pay.API.Types;
  using Amazon.Pay.API.WebStore;
  using Amazon.Pay.API.WebStore.Reports;
  using System;
  using System.Collections.Generic;
  
  public class Sample
  {
      public WebStoreClient InitiateClient()
      {
          // set up config
          var payConfiguration = new ApiConfiguration
          (
              region: Region.${data.region.toUpperCase()},
              environment: Environment.Sandbox,
              publicKeyId: "${data.publicKeyId}",
              privateKey: "YOUR_PRIVATE_KEY"
          );
  
          // init API client
          var client = new WebStoreClient(payConfiguration);
 
          // init Headers
          var myHeaderKey = "x-amz-pay-idempotency-key";
          var myHeaderValue = Guid.NewGuid().ToString();
          var headers = new Dictionary<string, string> { { myHeaderKey, myHeaderValue } };
  
          // send the request
          GetReportDocumentResponse result = client.GetReportDocument("${data.pathParam}", headers);
  
          // check if API call was successful
          if (!result.Success)
          {
              // handle the API error (use Status field to get the numeric error code)
          }
  
          // do something with the result, for instance:
          Console.WriteLine(report.RawResponse);
      }
  }`,
      nodejs: `
  const fs = require('fs');
  const Client = require('@amazonpay/amazon-pay-api-sdk-nodejs');
  
  const config = {
      publicKeyId: '${data.publicKeyId}',
      privateKey: fs.readFileSync('YOUR_PRIVATE_KEY'),
      region:  '${data.region}',
      sandbox: true
  };
                  
  const testPayClient = new Client.WebStoreClient(config);
  const response = testPayClient.getReportDocument('${data.pathParam}');`,
      other: `
  ${data.method} ${data.urlFragment} HTTP/1.1
  Accept: application/json
  Authorization: ${data.authorization}       
  X-Amz-Pay-Date: ${data.date}
  X-Amz-Pay-Host: ${data.host}
  X-Amz-Pay-Region: ${data.region}
  Content-type: application/json
  Host : ${data.host}`,
    };
}